import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomHeaderComponent } from './custom-header/custom-header.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog';
import { SharedMaterialModule } from './shared-material.module';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { RowTooltipComponent } from './row-tooltip-component/row-tooltip.component';
import { ManagePasswordDialogComponent } from './manage-password-dialog/manage-password-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    CustomHeaderComponent,
    SideNavComponent,
    UnauthorizedComponent,
    ConfirmationDialogComponent,
    RowTooltipComponent,
    ManagePasswordDialogComponent
  ],
  imports: [
    CommonModule,
    SharedMaterialModule,
    FormsModule,
    ReactiveFormsModule, 
  ],
  exports: [
    CustomHeaderComponent,
    SideNavComponent,
    UnauthorizedComponent,
    ConfirmationDialogComponent,
    RowTooltipComponent,
    ManagePasswordDialogComponent,
    SharedMaterialModule,
  ]
})
export class SharedModule { }